import * as yup from 'yup';
import { MealType } from '../../../app/data/models/mealType';
import { TFunction } from 'i18next';
import { languageMap } from '../../../app/data/models/common/localizedLanguage';
import { LanguageCode } from '../../../app/data/models/common/localizedLanguage';
import { MealItemFormData } from '../../../app/data/models/mealItems/mealItemFormData';

export const mealItemValidationSchema = (
  t: TFunction,
  languageCodes: LanguageCode[]
): yup.ObjectSchema<MealItemFormData> => {
  const languageNameShape = languageCodes.reduce(
    (acc, code) => ({
      ...acc,
      [code]: yup
        .string()
        .required(
          t('meal-item.validation.name-required', { field: languageMap[code] })
        ),
    }),
    {}
  );

  const languageDescriptionShape = languageCodes.reduce(
    (acc, code) => ({
      ...acc,
      [code]: yup.string().required(
        t('meal-item.validation.description-required', {
          field: languageMap[code],
        })
      ),
    }),
    {}
  );

  return yup.object({
    id: yup.string().optional(),
    names: yup.object().shape(languageNameShape).required(),
    descriptions: yup.object().shape(languageDescriptionShape).notRequired(),
    price: yup
      .number()
      .required(t('meal-item.validation.price-required'))
      .min(0),
    picture: yup.mixed<File>().nullable().optional(),
    pictureUrl: yup.string().optional(),
    kitchenId: yup
      .string()
      .required(t('meal-item.validation.kitchen-required')),
    mealType: yup
      .mixed<MealType>()
      .oneOf(Object.values(MealType) as MealType[])
      .required(t('meal-item.validation.meal-type-required')),
    isAvailable: yup.boolean().required(),
  }) as yup.ObjectSchema<MealItemFormData>;
};
